module.exports = __webpack_public_path__ + "static/media/footerV2.357e60ac.png";